import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { InputLabel, Select } from '@mui/material'
// import { Wrapper, FormLabel, FormError, FormSelectWrap, StyledMenuItem } from './style'
import { Wrapper, FormSelectWrap, StyledMenuItem, LabelWrapper, FormReq, FormLabel, FormError, FormPlaceholder } from './style'
// import { ArrowDownIos } from '../../assets/img/icons'

const MuiSelect = (props) => {
  const {
    data,
    placeholder,
    onChange,
    selectlabel = 'label',
    selectvalue = 'value',
    minwidth = '100%'
  } = props

  const [selectedValue, setSelectedValue] = useState()

  const handleChange = (event) => {
    setSelectedValue(event.target.value)
    const selectedData = { value: event.target.value, label: event.target.name }
    onChange(event, selectedData)
  }

  return (
  <Wrapper>
      {props.title && <LabelWrapper>
        {props.title && <FormLabel title={`${props?.required ? 'This is a required field!' : ''}`} bold={props?.bold}>
          {props.title}{props?.required && <FormReq> *</FormReq>}
        </FormLabel>}
        {props?.endAdornment && props?.endAdornment}
      </LabelWrapper>}
      <FormSelectWrap variant={props?.varient || 'standard'} className='selectWrap' style={{ minWidth: minwidth }}>
        {props?.placeholder && props?.value === '' && <FormPlaceholder className={`formPlaceholder ${props?.label ? 'isLabel' : ''} ${props?.disabled ? 'isDisabled' : ''}`}>{props.placeholder}</FormPlaceholder>}
        {props?.label && <InputLabel id={props.name} className='selectPlaceholder'>{props.label}</InputLabel>}
        {props?.data &&
          <Select
            {...props}
            labelId={props.name}
            id={props.name}
            data-placeholder={selectedValue || props.value ? '' : placeholder}
            value={props.value}
            onChange={handleChange}
          >
            {data.map((s, i) =>
              <StyledMenuItem single='true' key={i} value={s[selectvalue]}>
                {s[selectlabel] || ''}
              </StyledMenuItem>)
            }
          </Select>
        }
      </FormSelectWrap>
      {props?.error && <FormError className='selectError'>{props?.error}</FormError>}
  </Wrapper>
  )
}

MuiSelect.propTypes = {
  data: PropTypes.array,
  label: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  error: PropTypes.string,
  required: PropTypes.bool,
  bold: PropTypes.bool,
  disabled: PropTypes.bool,

  varient: PropTypes.string,
  name: PropTypes.string,
  endAdornment: PropTypes.node,
  value: PropTypes.string,
  minwidth: PropTypes.string,
  onChange: PropTypes.func,
  selectlabel: PropTypes.string,
  selectvalue: PropTypes.string,
  size: PropTypes.string,
  placeholder: PropTypes.string,
  menuprops: PropTypes.object
}

export default MuiSelect
